import * as React from 'react'

import { cn } from '../../lib/utils'

const Input = React.forwardRef<HTMLInputElement, React.ComponentPropsWithoutRef<'input'>>(
  function Input({ className, type, ...props }, ref) {
    return (
      <input
        ref={ref}
        type={type}
        data-slot="input"
        className={cn(
          'h-9 w-full min-w-0 rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm dark:bg-input/30',
          'focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50',
          'aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40',
          // Cascade from a wrapping <Field data-invalid> — the maestro
          // form pattern attaches `data-invalid` to the Field wrapper, not
          // to the input itself. Without this variant, `aria-invalid` alone
          // never fires on these forms and invalid styling is invisible.
          // The `group/field` name is set by the Field primitive, so we
          // can't accidentally collect data-invalid from an unrelated
          // ancestor group.
          'group-data-[invalid=true]/field:border-destructive group-data-[invalid=true]/field:ring-destructive/20 dark:group-data-[invalid=true]/field:ring-destructive/40',
          className
        )}
        {...props}
      />
    )
  }
)

export { Input }
